export const resolveSalesStatusCategory = (row) => {
  const rawStatus = String(row?.status_key || row?.status || row?.status_name || row?.stage || '')
    .trim()
    .toLowerCase();

  if (rawStatus.includes('cancel')) {
    return 'canceled';
  }

  if (rawStatus.includes('project') || rawStatus.includes('proyecto')) {
    return 'open';
  }

  if (
    rawStatus.includes('close')
    || rawStatus.includes('cerrad')
    || rawStatus.includes('won')
    || rawStatus.includes('lost')
    || rawStatus.includes('ganad')
    || rawStatus.includes('perdid')
  ) {
    return 'closed';
  }

  return 'open';
};

export const resolveSalesStatusClass = (row) => {
  const category = resolveSalesStatusCategory(row);

  if (category === 'canceled' || category === 'closed') {
    return 'app-status-inactive';
  }

  return 'app-status-active';
};
